import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  padding: 0 20px;
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: 50%;
  transform: translateX(-50%);
  min-width: 850px;
`;
